import React, { Component } from 'react';
import './App.css';

export class Home extends Component {
  render() {
    return (
      <div className="Home">
        <h1 className="centered">Camino Statistics</h1>

        <img src="./img/km790sign.jpg" alt="" className="pull-right in-text-img" />

        <p><span className="list-item-title">What?</span>
          This site summarizes data from the <a href="https://oficinadelperegrino.com/en/statistics/" target="_blank" rel="noopener noreferrer">Pilgrim's Office data page</a> about pilgrims finishing the Camino de Santiago. It compares yearly data and shows it graphically.
        </p>


        <p><span className="list-item-title">How?</span>
          Choose a data category from the menu at the top of the page.
          Each page has comments, a data table, and some charts.
          You can hide these selectively.
          Note that a few tables have many rows and are divided in to pages.
        </p>


        <p><span className="list-item-title">Why?</span>
          We created this site because we found it hard to get and compare the statistics about
          Camino de Santiago pilgrims easily and quickly from the Cathedral de Santiago site.
          It is hard to compare years since you can only see one year or month at a time.
          We created this site to help with that.
        </p>

        <p><span className="list-item-title">Who?</span>
          This site was created by Charlie and Wynette.
          You can find links to the blogs for our three Caminos at our <a href="http://wynchar.com/" target="_blank" rel="noopener noreferrer"> website</a>. You can contact us at cpcrowley@gmail.com. Please do so if you have any suggestions, questions, or corrections.
        </p>


        <p><span className="list-item-title">The Data:</span>
          The data used here are taken from the <a href="https://oficinadelperegrino.com" target="_blank" rel="noopener noreferrer">Pilgrim's Office</a> site. The statistics page is <a href="https://oficinadelperegrino.com/en/statistics/" target="_blank" rel="noopener noreferrer">here</a>.
        </p>
        <img src="./img/sillouette1.jpg" alt="" className="pull-right in-text-img" />

        <p><span className="list-item-title">Resizing:</span>
          The charts and tables resize to fit the screen so if you resize the window or
          rotate your mobile device, try moving to another page (like back to "About this site")
          and then back again to get the charts to redraw to fit the new window.
        </p>

        <p><span className="list-item-title">Changes and Corrections:</span>
          You can help by sending in any changes you would like to see, or corrections, or typos, etc.
        </p>

        <p><span className="list-item-title">Years covered</span>
          The Pilgrims's Office publishes statistics starting in 2004.
        </p>

        <p><span className="list-item-title">Percentages</span>
          All percentages are rounded to the nearest whole percent.
          So a "1%" is really anything from 0.5% to 1.49% percent and a "0%"
          is really from 0.0% to 0.49%.
          So it can show 0% and the raw data might not be 0.
        </p>

        <p><span className="list-item-title">Totals</span>
          The total number of pilgrims is steadily increasing over the years.
          The total seems to be going up about 10% per year.
          The exceptions are on Holy Years.
        </p>

        <p><span className="list-item-title">Holy years</span>
          2004 and 2010 were <em>Holy Years</em> when the church allows more generous
          indulgences for walking the Camino. There are always many more pilgrims
          in Holy Years.
        </p>
        <img src="./img/cathedrals1.jpg" alt="" className="pull-right in-text-img" />
        
        <p><span className="list-item-title">Technical Information: </span>
          Originally we collected the data as HTML and converted it to a JSON files.
          Recently the Pilgrim's Office converted the page into a web app that
          gets the data in JSON format from an HTTP POST request.
          This is how we get the raw JSON data. We combine that into a single JSON
          input file. This is read by the web page.
          The Github page for the web page and node.js data preparation programs is <a href="https://github.com/cpcrowley/Camino-de-Santiago-Pilgrim-Statistics" target="_blank" rel="noopener noreferrer"> here</a>. The data files are in that Github repository.
          Or email us if you would like a copy of the JSON data.
        </p>

        <p><span className="list-item-title">Last updated</span>
          on March 4, 2018. Valid data through December 2017.
        </p>


      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Home.js